<div *ngIf="tableReady">
  <app-table [table]="table"></app-table>
</div>

<div *ngIf="!tableReady" class="loading-spinner-container">
  <div class="spinner-border text-primary loading-spinner-md" role="status">
    <span class="visually-hidden-focusable" i18n="@@Loading">Loading...</span>
  </div>
</div>
